import { InputHTMLAttributes, ReactNode } from 'react'

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  label?: string
  error?: string
  rightIcon?: ReactNode
}

export default function Input({ label, error, rightIcon, className = '', ...props }: InputProps) {
  return (
    <div className="w-full">
      {label && (
        <label className="block text-sm font-medium text-gray-300 mb-2">
          {label}
        </label>
      )}
      <div className="relative">
        <input
          className={`w-full px-4 py-3 bg-gray-800 border rounded-xl focus:outline-none focus:border-primary text-center ${error ? 'border-red-500' : 'border-gray-600'} ${rightIcon ? 'pl-4 pr-12' : ''} ${className}`}
          {...props}
        />
        {rightIcon && (
          <div className="absolute left-4 top-1/2 -translate-y-1/2">
            {rightIcon}
          </div>
        )}
      </div>
      {error && (
        <p className="text-xs text-red-400 mt-1 text-center">{error}</p>
      )}
    </div>
  )
}